import { Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { Router,ActivatedRoute } from '@angular/router';
import { MatDrawer } from '@angular/material/sidenav';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { AuditoriasService } from '../../services/auditorias.service';
import { FormGroup, FormBuilder } from '@angular/forms';

import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSnackBar } from '@angular/material/snack-bar';
import {PageEvent} from '@angular/material/paginator';


const ELEMENT_DATA: any[] = [];


@Component({
    selector   : 'auditorias',
    templateUrl: './auditorias.component.html',
    styleUrls  : ['./auditorias.component.scss']
})
export class AuditoriasComponent
{
    displayedColumns: string[] = ['actividad', 'usuario','perfil','fecha','tipo'];
    dataSource = ELEMENT_DATA;
    filterForm: FormGroup;

    @ViewChild('drawer') sidenav: MatDrawer;
    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    selection: any;

    basicSlice = 10;
    elementCount = 0;

    constructor(public dialog: MatDialog,
                private auditoriasService: AuditoriasService,
                private _snackBar: MatSnackBar,
                public router: Router,
                private _formBuilder: FormBuilder,
                private route: ActivatedRoute
                ) {}

    ngOnInit() {

      this.filterForm = this._formBuilder.group({});
      this.loadData();
    }

    loadData():void{
      this.getElements(0);
      this.auditoriasService.countAll(this.filterForm).pipe().subscribe(req => {
          this.elementCount = req.body;
      });

    }

    getElements(pageIndex){

        this.dataSource = [];
        this.filterForm.value["pagina"] = pageIndex;
        this.filterForm.value["cantidad"] = this.basicSlice;

        this.auditoriasService.getAll(this.filterForm).pipe().subscribe(req => {
            this.dataSource = req.body;
            //this.dataSource = [...this.dataSource];
            });
    }

    OnePageChange(event: PageEvent) {
        this.basicSlice = event.pageSize;
        this.getElements(event.pageIndex);
    }
}
